module.exports = __webpack_public_path__ + "static/media/member (4).5f93b9f6.png";